import React, { useState } from 'react';
import styled from 'styled-components';
import { getFontWeight } from '../../helpers/utils';
import StarIcon from '../../assets/icons/StarIcon';

const StarRatingElement = ({
  name,
  is_required = false,
  value,
  lexicon,
  onChange = () => {},
  disabled = false,
  attributes,
  font,
  min = 1,
  max = 5,
}) => {
  const [hovered, setHovered] = useState(null);

  const count = Math.max(1, max - min + 1);
  const current = hovered ?? (value ? parseInt(value, 10) : 0);

  const handleClick = star => {
    if (disabled) return;
    // Toggle off if clicking the same star
    const next = parseInt(value, 10) === star ? 0 : star;
    onChange(lexicon, next === 0 ? '' : String(next));
  };

  return (
    <StarRatingWrapper>
      {name && (
        <div className="star-label">
          <span
            style={{
              color: attributes?.font?.color || font?.color,
              fontSize: attributes?.font?.size || font?.size,
              fontWeight: getFontWeight(attributes?.font?.style || font?.style),
              fontFamily: attributes?.font?.name || font?.name,
            }}>
            {name}
          </span>
          {is_required && <span className="required-star">!</span>}
        </div>
      )}
      <div className="stars" onMouseLeave={() => setHovered(null)}>
        {Array.from({ length: count }, (_, i) => {
          const star = min + i;
          const filled = star <= current;
          return (
            <button
              key={star}
              type="button"
              disabled={disabled}
              className={`star${filled ? ' star--filled' : ''}${disabled ? ' star--disabled' : ''}`}
              onClick={() => handleClick(star)}
              onMouseEnter={() => !disabled && setHovered(star)}
              aria-label={`${star} star${star !== 1 ? 's' : ''}`}>
              <StarIcon filled={filled} hovered={hovered !== null && star <= hovered} />
            </button>
          );
        })}
      </div>
    </StarRatingWrapper>
  );
};


const StarRatingWrapper = styled.div`
  width: 100%;

  .star-label {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 10px;

    span {
      font-family: 'Inter', sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #2a3348;
    }

  }

  .stars {
    display: flex;
    flex-direction: row;
    gap: 6px;
  }

  .star {
    width: 52px;
    height: 52px;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    transition: transform 0.1s ease;

    &:hover:not(.star--disabled) {
      transform: scale(1.12);
    }

    &--disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;

export default StarRatingElement;
